module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya_ekimae/nagoya_ekimae_sns_02-70c2194323ee7c1940510c43db3d40aa.jpg";